@if (detailData?.id && (isAdmin || isDispatchUser)) {
  <div class="d-flex gap-2 mb-2">
    <button
      class="btn btn-md btn-outline-secondary"
      (click)="routeToJobDetailPage()"
    >
      View Details
    </button>

    @if (
      detailData?.status?.status_identity?.value == 9 && lastStatus?.status?.id
    ) {
      <button class="btn btn-md btn-outline-primary" (click)="moveJobBack()">
        Reopen Job
      </button>
    }

    @if (!configuredMailData?.length) {
      <button
        class="btn btn-md btn-success"
        (click)="
          openSendDocketTemplate(sendDocketTemplate, reportConfirmationTemplate)
        "
      >
        {{
          detailData?.status?.status_identity?.value == 9
            ? "Send Docket"
            : "Resend Docket"
        }}
      </button>
    }
  </div>
  @if (configuredMailData?.length) {
    <div class="border rounded p-1 p-lg-4 report-preview mb-2">
      @if (configuredMailData?.length > 1) {
        <ul>
          @for (schedule of configuredMailData; track $index) {
            <li class="mb-2">
              <ng-template
                *ngTemplateOutlet="
                  configuredMailScheduleTemplate;
                  context: { value: schedule }
                "
              ></ng-template>
            </li>
          }
        </ul>
      } @else {
        <ng-template
          *ngTemplateOutlet="
            configuredMailScheduleTemplate;
            context: { value: configuredMailData?.[0] }
          "
        ></ng-template>
      }
    </div>
  }
}

@if (detailData?.invoice_job?.invoice_num && (isAdmin || isDispatchUser)) {
  <div class="mb-2 report-preview">
    <div
      class="border p-2 p-lg-3 rounded bg-dark-subtle text-dark"
      [class.small]="!largeView"
    >
      <div class="row row-cols-"></div>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <div class="fw-semibold">
            {{ detailData?.status?.name }}
          </div>
          <div class="mb-2">
            Invoice ID:
            {{ detailData?.invoice_job?.invoice_num }}
          </div>
          @if (detailData?.invoice_job?.invoice_id) {
            <span
              class="px-2 py-1 small rounded bg-secondary-subtle border text-center border-dark hover"
              role="button"
              (click)="printInvoice(detailData?.invoice_job?.invoice_id)"
            >
              Open Invoice
            </span>
          }
        </div>
        <div>
          <div>
            Amount
            <span class="float-end ms-4"
              >{{ regionCurrencySymbol
              }}{{
                detailData?.invoice_job?.additional_info?.job_invoice_sale_amount?.toFixed(
                  2
                )
              }}</span
            >
          </div>
          <div>
            GST
            <span class="float-end ms-4">
              {{ regionCurrencySymbol
              }}{{
                detailData?.invoice_job?.additional_info?.job_invoice_tax_amount?.toFixed(
                  2
                )
              }}</span
            >
          </div>
          <div class="fw-semibold">
            Total
            <span class="float-end ms-4">
              {{ regionCurrencySymbol
              }}{{
                detailData?.invoice_job?.additional_info?.job_invoice_total_amount?.toFixed(
                  2
                )
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (detailData?.internal_notes) {
  @if (isAdmin || isDispatchUser) {
    <div class="mb-2 report-preview">
      <div class="border p-3 rounded">
        <div class="mb-3 small fw-semibold">Internal Notes</div>
        <div class="gt-multi-line">
          {{ detailData?.internal_notes }}
        </div>
      </div>
    </div>
  }
}
@if (detailData?.status?.status_identity?.value == 9) {
  <div class="row row-cols-2 mb-3 row-cols-lg-6">
    <div class="col">
      @if (detailData?.service_type?.enable_comments === true) {
        <button
          class="btn btn-primary btn-md w-100"
          (click)="openAddCommentTemplate(commentRef)"
        >
          + Add Comment
        </button>
      }
    </div>
    <div class="col">
      @if (detailData?.service_type?.enable_uploads === true) {
        <button
          class="btn btn-outline-primary btn-md w-100"
          (click)="openCamPopup()"
        >
          + Attach Photo
        </button>
      }
    </div>
  </div>
}
@if (detailData?.company?.is_subcontracting) {
  <div
    class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
  >
    {{ detailData?.company?.company_name }} is a Prime Contractor
  </div>
}
<div class="p-lg-5 p-2 report-preview shadow bg-white text-black">
  @if (eventsOutsideStatusTimeStamps?.length) {
    <div class="alert alert-warning text-center">
      WARNING: There are events occurring outside the onsite window.
    </div>
  }
  @if (isAdmin || isDispatchUser) {
    <div
      class="d-flex gap-3 gap-lg-5 border border-1 rounded mb-2 py-2 px-1 showHideControls flex-wrap"
    >
      <div class="fw-semibold small">Show/Hide</div>
      <div
        (click)="
          updateData({
            hide_header: !detailData?.additional_info?.hide_header,
          })
        "
        role="button"
        [ngClass]="
          detailData?.additional_info?.hide_header
            ? 'opacity-50'
            : 'text-primary'
        "
        class="small"
      >
        Header
      </div>
      @if (!detailData?.additional_info?.hide_header) {
        <div
          (click)="
            updateData({
              hide_subscriber_header_details:
                !detailData?.additional_info?.hide_subscriber_header_details,
            })
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_subscriber_header_details
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Company Address
        </div>
      }

      @if (detailData?.company?.address_exists && !isSubContractingClient) {
        <div
          (click)="
            updateData({
              hide_client_detail:
                !detailData?.additional_info?.hide_client_detail,
            })
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_client_detail
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Client Address
        </div>
      }
      @if ([3, 6].includes(detailData?.service_type?.type_identity)) {
        <!--https://app.shortcut.com/sendem/story/10604/allow-hide-show-docket-shift-information-in-scheduled-patrols-->
        <div
          (click)="
            updateData({
              hide_docket_number:
                !detailData?.additional_info?.hide_docket_number,
            })
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_docket_number
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Docket No.
        </div>
        <div
          (click)="
            updateData({
              hide_shift_info: !detailData?.additional_info?.hide_shift_info,
            })
          "
          role="button"
          [ngClass]="
            detailData?.additional_info?.hide_shift_info
              ? 'opacity-50'
              : 'text-primary'
          "
          class="small"
        >
          Shift Info
        </div>
      }
      <div
        (click)="
          updateData({
            hide_sub_biller: !detailData?.additional_info?.hide_sub_biller,
          })
        "
        role="button"
        [ngClass]="
          detailData?.additional_info?.hide_sub_biller
            ? 'opacity-50'
            : 'text-primary'
        "
        class="small"
      >
        Sub Biller
      </div>
    </div>
  }
  @if (detailData?.id) {
    @if (!detailData?.additional_info?.hide_header) {
      <div id="headerSection" class="header-container">
        <div class="subscriber_company_information_section">
          @if (!detailData?.additional_info?.hide_subscriber_header_details) {
            <div class="fw-bold">
              {{ job_details?.subscriber_info?.name }}
            </div>
            <div>{{ job_details?.subscriber_info?.address }}</div>
            <div>{{ job_details?.subscriber_info?.city }}</div>
            @if (job_details?.subscriber_info?.mobile_number) {
              <div>Ph: {{ job_details?.subscriber_info?.mobile_number }}</div>
            }
            <div>{{ job_details?.subscriber_info?.email }}</div>
          }
        </div>

        <div class="text-center">
          @if (job_details?.subscriber_info?.logo_url) {
            <img
              [ngClass]="largeView ? 'logo_img_large' : 'logo_img_mob'"
              alt="placeholder_logo"
              src="{{ job_details?.subscriber_info?.logo_url }}"
            />
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
            >
              Update Logo
            </div>
          } @else {
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
            >
              Upload Logo
            </div>
          }
        </div>
      </div>
    }
    <div class="report-type-heading">Job Completion Report</div>
    <!--CLIENT INFORMATION SECTION-->
    <div class="client_information_section mb-3">
      <div>{{ job_details?.client }}</div>
      @if (!detailData?.additional_info?.hide_client_detail) {
        @if (job_details?.custom_address) {
          <div class="gt-multi-line">{{ job_details?.custom_address }}</div>
        }
        <div>
          {{ job_details?.address }}
        </div>

        <div>
          {{ job_details?.city }}
        </div>
      }
    </div>
    <div class="patrol-table mt-3">
      @if (job_details?.time_zone && job_details?.time_zone_diff) {
        <div
          style="
            font-size: 10px;
            padding-bottom: 0.5rem;
            color: #333;
            font-weight: bold;
            font-style: italic;
          "
        >
          Timestamps shown in {{ job_details.time_zone }}
          {{ job_details.time_zone_diff }}
        </div>
      }
      <table style="width: 100%; max-width: 100%" class="responsive">
        @if (largeView) {
          <tr>
            <td class="cell-heading">Date</td>
            <td
              [attr.colspan]="
                (detailData?.status?.status_identity?.value == 9 ||
                  detailData?.sites?.[0]?.sub_biller?.id) &&
                !detailData?.additional_info?.hide_sub_biller
                  ? 1
                  : 3
              "
            >
              <div class="d-flex">
                {{ job_details?.report_date }}
                @if (
                  detailData?.status?.status_identity?.value == 9 &&
                  (isAdmin || isDispatchUser)
                ) {
                  <span
                    class="ms-1 edit-button"
                    (click)="openReportDateTemplate(reportDateTemplateRef)"
                  >
                    <span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </div>
            </td>
            @if (
              (detailData?.status?.status_identity?.value == 9 ||
                detailData?.sites?.[0]?.sub_biller?.id) &&
              !detailData?.additional_info?.hide_sub_biller
            ) {
              <td class="cell-heading">Sub Biller</td>
              <td>
                <div class="d-flex">
                  {{ detailData?.sites?.[0]?.sub_biller?.company_name }}
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      class="ms-1 edit-button"
                      (click)="openSubBillerTemplate()"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </td>
            }
          </tr>
        } @else {
          <tr>
            <td class="cell-heading">Date</td>
            <td>
              <div class="d-flex">
                {{ job_details?.report_date }}
                @if (
                  detailData?.status?.status_identity?.value == 9 &&
                  (isAdmin || isDispatchUser)
                ) {
                  <span
                    class="ms-1 edit-button"
                    (click)="openReportDateTemplate(reportDateTemplateRef)"
                  >
                    <span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </div>
            </td>
          </tr>
          @if (
            (detailData?.status?.status_identity?.value == 9 ||
              detailData?.sites?.[0]?.sub_biller?.id) &&
            !detailData?.additional_info?.hide_sub_biller
          ) {
            <tr>
              <td class="cell-heading">Sub Biller</td>
              <td>
                <div class="d-flex">
                  {{ detailData?.sites?.[0]?.sub_biller?.company_name }}
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      class="ms-1 edit-button"
                      (click)="openSubBillerTemplate()"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </td>
            </tr>
          }
        }
        @if (largeView) {
          @if (!detailData?.additional_info?.hide_docket_number) {
            <tr>
              <td class="cell-heading">Docket No.</td>
              <td
                [attr.colspan]="
                  [0, 5, 2].includes(detailData?.service_type?.type_identity) &&
                  (detailData?.status?.status_identity?.value == 9 ||
                    job_details?.ext_job_id)
                    ? 1
                    : 3
                "
              >
                <div class="d-flex enable-text-select">
                  {{ job_details?.job_key }}
                  @if (job_details?.job_key) {
                    <span
                      (click)="copyContentToClipBoard(job_details?.job_key)"
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                </div>
              </td>
              @if (
                [0, 5, 2].includes(detailData?.service_type?.type_identity) &&
                (detailData?.status?.status_identity?.value == 9 ||
                  job_details?.ext_job_id)
              ) {
                <td class="cell-heading">Job No.</td>
                <td>
                  <div class="d-flex enable-text-select">
                    {{ job_details?.ext_job_id }}
                    @if (job_details?.ext_job_id) {
                      <span
                        (click)="
                          copyContentToClipBoard(job_details?.ext_job_id)
                        "
                      >
                        <i
                          class="fa-regular fa-copy fs-5 text-secondary ms-3"
                        ></i>
                      </span>
                    }
                    @if (
                      detailData?.status?.status_identity?.value == 9 &&
                      (isAdmin || isDispatchUser)
                    ) {
                      <span
                        (click)="
                          modifyExternalJobId(modifyExternalJobIdTemplate)
                        "
                        class="ms-2 edit-button"
                      >
                        <span id="edit-button-placeholder d-none"></span>
                      </span>
                    }
                  </div>
                </td>
              }
            </tr>
          }
          <tr>
            <td class="cell-heading">Job Type</td>
            <td
              [attr.colspan]="
                [0, 5].includes(detailData?.service_type?.type_identity) &&
                (detailData?.status?.status_identity?.value == 9 ||
                  job_details?.monitoring_company)
                  ? 1
                  : 3
              "
            >
              <div class="d-flex enable-text-select">
                @if (job_details?.response_type) {
                  {{ job_details?.type }} -
                  <span class="fw-semibold ms-1">
                    {{ job_details?.response_type }}</span
                  >
                } @else {
                  {{ job_details?.type }}
                }
                @if (
                  [0, 1, 5].includes(detailData?.service_type?.type_identity) &&
                  (isAdmin || isDispatchUser) &&
                  detailData?.status?.status_identity?.value == 9
                ) {
                  <span
                    class="ms-1 edit-button"
                    (click)="
                      [0, 5].includes(detailData?.service_type?.type_identity)
                        ? openUpdateResponseTypeTemplate(
                            responseTypeTemplateRef
                          )
                        : openUpdateServiceTypeTemplate(serviceTypeTemplateRef)
                    "
                  >
                    <span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </div>
            </td>
            @if (
              [0, 5].includes(detailData?.service_type?.type_identity) &&
              (detailData?.status?.status_identity?.value == 9 ||
                job_details?.monitoring_company)
            ) {
              <td class="cell-heading">Monitoring Company</td>
              <td>
                <div class="d-flex">
                  {{ job_details?.monitoring_company }}
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      class="ms-1 edit-button"
                      (click)="modifyMonitoringCompany(modifyMCTemplate)"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </td>
            }
          </tr>
        } @else {
          @if (!detailData?.additional_info?.hide_docket_number) {
            <tr>
              <td class="cell-heading">Docket No.</td>
              <td>
                <div class="d-flex">
                  <span class="enable-text-select">
                    {{ job_details?.job_key }}</span
                  >
                  <span (click)="copyContentToClipBoard(job_details?.job_key)">
                    <i class="fa-regular fa-copy fs-5 text-secondary ms-3"></i>
                  </span>
                </div>
              </td>
            </tr>
          }
          @if (
            [0, 5].includes(detailData?.service_type?.type_identity) &&
            (detailData?.status?.status_identity?.value == 9 ||
              job_details?.ext_job_id)
          ) {
            <tr>
              <td class="cell-heading">Job No.</td>
              <td>
                <div class="d-flex">
                  <span class="enable-text-select">
                    {{ job_details?.ext_job_id }}
                  </span>
                  @if (job_details?.ext_job_id) {
                    <span
                      (click)="copyContentToClipBoard(job_details?.ext_job_id)"
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      (click)="modifyExternalJobId(modifyExternalJobIdTemplate)"
                      class="ms-2 edit-button"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </td>
            </tr>
          }
          <tr>
            <td class="cell-heading">Job Type</td>
            <td>
              <div class="d-flex enable-text-select">
                {{ job_details?.type }}
                @if (job_details?.response_type) {
                  -
                  <span class="fw-semibold ms-1">
                    {{ job_details?.response_type }}</span
                  >
                }

                @if (
                  [0, 1, 5].includes(detailData?.service_type?.type_identity) &&
                  (isAdmin || isDispatchUser) &&
                  detailData?.status?.status_identity?.value == 9
                ) {
                  <span
                    class="ms-1 edit-button"
                    (click)="
                      [0, 5].includes(detailData?.service_type?.type_identity)
                        ? openUpdateResponseTypeTemplate(
                            responseTypeTemplateRef
                          )
                        : openUpdateServiceTypeTemplate(serviceTypeTemplateRef)
                    "
                  >
                    <span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </div>
            </td>
          </tr>
          @if (
            [0, 5].includes(detailData?.service_type?.type_identity) &&
            (detailData?.status?.status_identity?.value == 9 ||
              job_details?.monitoring_company)
          ) {
            <tr>
              <td class="cell-heading">Monitoring Company</td>
              <td>
                {{ job_details?.monitoring_company }}
                @if (
                  detailData?.status?.status_identity?.value == 9 &&
                  (isAdmin || isDispatchUser)
                ) {
                  <span
                    class="ms-1 edit-button"
                    (click)="modifyMonitoringCompany(modifyMCTemplate)"
                  >
                    <span id="edit-button-placeholder d-none"></span>
                  </span>
                }
              </td>
            </tr>
          }
        }
        <tr>
          <td class="cell-heading">Location</td>
          @for (item of job_details?.site_address; track item) {
            <td colspan="3">
              <span class="fw-semibold me-2">{{ item?.site_name }}</span>
              <span class="enable-text-select">
                {{ item?.address }} {{ item?.city }}
              </span>
            </td>
          }
        </tr>
        @if (
          detailData?.roster_scheduler?.repeat_type &&
          !detailData?.additional_info?.hide_shift_info
        ) {
          <td class="cell-heading">Shift</td>
          <td colspan="3">
            <div class="d-flex">
              {{
                detailData?.roster_scheduler?.shiftStartDateTime
                  | customDate: "d MMM y HH:mm"
              }}
              -
              {{
                detailData?.roster_scheduler?.shiftEndDateTime
                  | customDate: "d MMM y HH:mm"
              }}
              [{{ detailData?.roster_scheduler?.shiftDuration }}]
            </div>
          </td>
        }
        @if (
          [0, 1, 5, 3, 6].includes(detailData?.service_type?.type_identity)
        ) {
          @for (item of statusTimeStamps; track item) {
            <tr>
              <td class="cell-heading">
                {{ item?.value }}
                @if (
                  item?.sortInfo &&
                  detailData?.status?.status_identity?.value == 9
                ) {
                  <div class="float-end">
                    @if (item?.sortInfo === "up") {
                      <span>
                        <i class="fa-solid fa-arrow-up text-danger"></i
                      ></span>
                    } @else {
                      <span>
                        <i class="fa-solid fa-arrow-down text-danger"></i
                      ></span>
                    }
                  </div>
                }
              </td>
              <td colspan="3">
                <div class="status-change d-flex">
                  {{
                    item?.event_time
                      | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                  }}
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      (click)="editStatusTimeStamp(statusTimeUpdateTemplateRef)"
                      class="ms-3 edit-button"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </td>
            </tr>
          }
        }
        @if (
          (isAdmin || isDispatchUser) &&
          detailData?.seal_info?.internal_check &&
          [0, 5].includes(detailData?.service_type?.type_identity)
        ) {
          <tr>
            <td colspan="6">
              <div class="d-flex">
                <div class="pe-2">
                  <dd class="gt-multi-line enable-text-select">
                    <div class="fw-semibold">
                      {{
                        detailData?.seal_info?.site_sealed
                          ? "Site Sealed"
                          : "Site Not Sealed"
                      }}
                    </div>
                    @if (
                      !detailData?.seal_info?.site_sealed &&
                      detailData?.seal_info?.uncleared_reason
                    ) {
                      Reason: {{ detailData?.seal_info?.uncleared_reason }}
                    }
                    @if (
                      detailData?.seal_info?.site_sealed &&
                      detailData?.seal_info?.cleared_by
                    ) {
                      Cleared By:
                      {{ detailData?.seal_info?.cleared_by }}
                    }
                  </dd>
                </div>
                <div>
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      (click)="openSealInfoTemplate(sealInfoTemplateRef)"
                      class="edit-button"
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </div>
            </td>
          </tr>
        }
        @if (
          detailData?.status?.status_identity?.value == 9 ||
          job_details?.additional_info
        ) {
          <tr>
            <td class="cell-heading line-height">Job Details</td>
            <td colspan="3">
              <div class="d-flex">
                <div class="pe-2">
                  <div class="gt-multi-line fs-6 enable-text-select">
                    {{ job_details?.additional_info }}
                  </div>
                </div>
                <div>
                  @if (job_details?.additional_info) {
                    <span
                      (click)="
                        copyContentToClipBoard(job_details?.additional_info)
                      "
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      class="ms-2 edit-button"
                      (click)="
                        modifyJobExtraInfo(
                          jobExtraInfoTemplateRef,
                          'ai',
                          detailData?.request_details
                        )
                      "
                    >
                      <span id="edit-button-placeholder d-none"></span>
                    </span>
                  }
                </div>
              </div>
            </td>
          </tr>
        }
      </table>
    </div>
    <!-- REPORT SUMMARY -->
    <div class="row row-cols-1 row-cols-lg-2 my-3 align-items-center">
      @if (
        (isAdmin || isDispatchUser) &&
        (hasStatusUpdates ||
          photoUploadPresent ||
          summaryData?.length ||
          welfareCheckPresent ||
          ([6].includes(detailData?.service_type?.type_identity) &&
            (cpScanPresent || completedTasksPresent)))
      ) {
        <div class="col-12 col-lg-2 fw-bold">
          <div [ngClass]="!summaryData?.length ? 'opacity-50' : ''">
            Report Summary
          </div>
        </div>
        <div class="col-12 col-lg-10">
          <div
            class="ms-lg-3 border border-1 rounded d-flex gap-2 gap-lg-5 p-2 showHideControls"
          >
            <div class="fw-semibold small">Show/Hide</div>

            @if (hasStatusUpdates) {
              <div>
                <div
                  (click)="
                    updateData({
                      hide_status_changes:
                        !detailData?.additional_info?.hide_status_changes,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.hide_status_changes
                      ? 'opacity-50'
                      : 'text-primary'
                  "
                  class="small"
                >
                  Status Updates
                </div>
              </div>
            }
            @if (photoUploadPresent) {
              <div>
                <div
                  (click)="
                    updateData({
                      hide_uploads: !detailData?.additional_info?.hide_uploads,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.hide_uploads
                      ? 'opacity-50'
                      : 'text-primary'
                  "
                  class="small"
                >
                  Photo Uploads
                </div>
              </div>
            }
            @if (summaryData?.length) {
              <div>
                <div
                  (click)="
                    updateData({
                      hide_guard_column:
                        !detailData?.additional_info?.hide_guard_column,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.hide_guard_column
                      ? 'opacity-50'
                      : 'text-primary'
                  "
                  class="small"
                >
                  Guard Names
                </div>
              </div>
            }
            @if (welfareCheckPresent) {
              <div>
                <div
                  (click)="
                    updateData({
                      hide_welfare_checks:
                        !detailData?.additional_info?.hide_welfare_checks,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.hide_welfare_checks
                      ? 'opacity-50'
                      : 'text-primary'
                  "
                  class="small"
                >
                  Welfare Check Ins
                </div>
              </div>
            }
            @if ([6].includes(detailData?.service_type?.type_identity)) {
              @if (cpScanPresent) {
                <div
                  (click)="
                    updateData({
                      hide_cp_scans:
                        !detailData?.additional_info?.hide_cp_scans,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.hide_cp_scans
                      ? 'opacity-50'
                      : 'text-primary'
                  "
                  class="small"
                >
                  Checkpoint Scans
                </div>
              }
              @if (completedTasksPresent) {
                <div
                  (click)="
                    updateData({
                      show_completed_tasks:
                        !detailData?.additional_info?.show_completed_tasks,
                    })
                  "
                  role="button"
                  [ngClass]="
                    detailData?.additional_info?.show_completed_tasks
                      ? 'text-primary'
                      : 'opacity-50'
                  "
                  class="small"
                >
                  Completed Tasks
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
    @if (summaryData?.length) {
      @if (largeView) {
        <div class="patrol-table mb-5">
          <table class="w-100">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Time</th>
                <th>Event</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
                @if (
                  detailData?.status?.status_identity?.value == 9 &&
                  (isAdmin || isDispatchUser)
                ) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of summaryData; track row; let i = $index) {
                <tr id="section_up{{ i + 1 }}">
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="text-center"
                  >
                    {{ i + 1 }}
                  </td>
                  <td [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex">
                      <span
                        [ngClass]="
                          eventsOutsideStatusTimeStamps?.includes(row?.id)
                            ? 'text-danger'
                            : ''
                        "
                      >
                        {{
                          row?.event_time
                            | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                        }}
                      </span>
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <span
                          (click)="
                            editTimeStamp(
                              row,
                              eventTimeStampUpdateTemplateRef,
                              statusTimeUpdateTemplateRef
                            )
                          "
                          class="ms-1 edit-button"
                        ></span>
                      }
                    </div>
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="uppercase line-height"
                  >
                    @if (row?.file_url) {
                      <a
                        class="cursor-pointer"
                        (click)="
                          scrollToSection($event, 'section_down' + (i + 1))
                        "
                        style="color: #00538d"
                      >
                        {{ row?.action }}
                      </a>
                    } @else {
                      {{ row?.action }}
                    }
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="border-left: hidden"
                  >
                    <div class="d-flex">
                      <div class="gt-multi-line fs-6 enable-text-select">
                        {{ row?.value }}
                      </div>
                      @if (
                        row?.value && [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div>
                          <span (click)="copyContentToClipBoard(row?.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        </div>
                      }
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser) &&
                        [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div
                          class="ms-2"
                          (click)="editComment(row, commentRef)"
                        >
                          @if (row?.value) {
                            <span class="edit-button">
                              <span id="edit-button-placeholder d-none"></span>
                            </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row?.event_by }}
                    </td>
                  }
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <td>
                      <div>
                        @if ([7, 8, 19].includes(row?.event_action)) {
                          <div
                            class="ms-1"
                            (click)="
                              deleteRestoreUserUpdate({
                                event: row,
                                type: row?.is_deleted ? 'restore' : 'delete',
                              })
                            "
                          >
                            @if (row?.is_deleted) {
                              <span>
                                <i
                                  class="fs-5 fa-solid fa-trash-can-arrow-up text-secondary"
                                ></i>
                              </span>
                            } @else {
                              <span>
                                <i
                                  class="fs-5 fa-solid fa-circle-minus text-danger"
                                ></i>
                              </span>
                            }
                          </div>
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of summaryData; track row; let i = $index) {
              <tr id="section_up{{ i + 1 }}">
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div
                      class="small text-secondary d-flex"
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    >
                      <span
                        [ngClass]="
                          eventsOutsideStatusTimeStamps?.includes(row?.id)
                            ? 'text-danger'
                            : ''
                        "
                      >
                        {{
                          row?.event_time
                            | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                        }}
                      </span>
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <span
                          (click)="
                            editTimeStamp(
                              row,
                              eventTimeStampUpdateTemplateRef,
                              statusTimeUpdateTemplateRef
                            )
                          "
                          class="ms-2 edit-button"
                          ><span id="edit-button-placeholder d-none"></span
                        ></span>
                      }
                    </div>
                    <div>
                      @if (
                        [7, 8, 19].includes(row?.event_action) &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <div
                          class="ms-1"
                          (click)="
                            deleteRestoreUserUpdate({
                              event: row,
                              type: row?.is_deleted ? 'restore' : 'delete',
                            })
                          "
                        >
                          @if (row?.is_deleted) {
                            <span>
                              <i
                                class="fs-5 fa-solid fa-trash-can-arrow-up text-secondary"
                              ></i>
                            </span>
                          } @else {
                            <span>
                              <i
                                class="fs-5 fa-solid fa-circle-minus text-danger"
                              ></i>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between small text-secondary"
                  >
                    <div
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="uppercase line-height"
                    >
                      @if (row?.file_url) {
                        <a
                          class="cursor-pointer"
                          (click)="
                            scrollToSection($event, 'section_down' + (i + 1))
                          "
                          style="color: #00538d"
                        >
                          {{ row?.action }}
                        </a>
                      } @else {
                        {{ row?.action }}
                      }
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div
                        [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                        class="line-height"
                      >
                        {{ row?.event_by }}
                      </div>
                    }
                  </div>
                  <div [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex pt-2">
                      <div class="gt-multi-line fs-6 enable-text-select">
                        {{ row?.value }}
                      </div>
                      @if (
                        row?.value && [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div>
                          <span (click)="copyContentToClipBoard(row?.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        </div>
                      }
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser) &&
                        [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div (click)="editComment(row, commentRef)">
                          @if (row?.value) {
                            <span class="edit-button">
                              <span id="edit-button-placeholder d-none"></span>
                            </span>
                          } @else {
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    @if (
      detailData?.additional_info?.show_completed_tasks &&
      completedTasksData?.length
    ) {
      <div class="fw-bold p-2">Completed Tasks</div>
      @if (largeView) {
        <div class="patrol-table mb-5">
          <table class="w-100">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Time</th>
                <th>Task</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of completedTasksData; track row; let i = $index) {
                <tr>
                  <td class="text-center">
                    {{ i + 1 }}
                  </td>
                  <td>
                    <div class="d-flex">
                      {{
                        row?.updated_datetime
                          | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                      }}
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <span
                          (click)="
                            editTaskCompletedTimeStamp(
                              row,
                              eventTimeStampUpdateTemplateRef
                            )
                          "
                          class="ms-1 edit-button"
                          ><span id="edit-button-placeholder d-none"></span
                        ></span>
                      }
                    </div>
                  </td>
                  <td class="gt-multi-line">
                    {{ row?.task }}
                  </td>
                  <td style="border-left: hidden" class="gt-multi-line">
                    {{ row?.value }}
                    @if (row?.prompts?.length) {
                      @for (item of row?.prompts; track item) {
                        <div class="mb-2">
                          @for (dataItem of item?.data; track dataItem) {
                            @if (dataItem?.show_in_reports) {
                              <div>
                                <ng-template
                                  *ngTemplateOutlet="
                                    promptTemplate;
                                    context: { value: dataItem }
                                  "
                                ></ng-template>
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row?.event_by }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of completedTasksData; track row; let i = $index) {
              <tr>
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div class="small text-secondary d-flex">
                      {{
                        row?.updated_datetime
                          | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                      }}
                      @if (
                        detailData?.status?.status_identity?.value == 9 &&
                        (isAdmin || isDispatchUser)
                      ) {
                        <span
                          (click)="
                            editTaskCompletedTimeStamp(
                              row,
                              eventTimeStampUpdateTemplateRef
                            )
                          "
                          class="ms-1 edit-button"
                          ><span id="edit-button-placeholder d-none"></span
                        ></span>
                      }
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div class="line-height">
                        {{ row?.event_by }}
                      </div>
                    }
                  </div>

                  <div class="line-height small gt-multi-line">
                    {{ row?.task }}
                  </div>

                  <div class="gt-multi-line fs-6">
                    {{ row?.value }}
                    @if (row?.prompts?.length) {
                      @for (item of row?.prompts; track item) {
                        <div class="mb-2">
                          @for (dataItem of item?.data; track dataItem) {
                            @if (dataItem?.show_in_reports) {
                              <div>
                                <ng-template
                                  *ngTemplateOutlet="
                                    promptTemplate;
                                    context: { value: dataItem }
                                  "
                                ></ng-template>
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    <!-- DETAILS SECTION -->
    <div
      class="mt-3"
      style="box-decoration-break: clone; -webkit-box-decoration-break: clone"
    >
      @for (item of eventData; track item; let i = $index) {
        @if (item?.file_url && !item?.is_deleted) {
          <div id="section_down{{ i + 1 }}">
            <div class="d-flex mb-4">
              <div
                [ngClass]="
                  largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                "
              >
                <!-- @if (item?.download_url) {
                  <a
                    href="{{ item.download_url }}"
                    style="text-decoration: none"
                  >
                    <button class="btn btn-primary btn-sm mb-3">
                      Download Video
                    </button>
                  </a>
                } -->

                <!--TIMESTAMP-->
                <div
                  class="key-value d-flex gap-1 mb-2 fw-semibold"
                  [ngClass]="
                    eventsOutsideStatusTimeStamps?.includes(item?.id)
                      ? 'text-danger'
                      : ''
                  "
                >
                  {{
                    item?.event_time
                      | date: "dd MMM yyyy HH:mm" : timeZoneOffset
                  }}
                  @if (
                    detailData?.status?.status_identity?.value == 9 &&
                    (isAdmin || isDispatchUser)
                  ) {
                    <span
                      (click)="
                        editTimeStamp(item, eventTimeStampUpdateTemplateRef)
                      "
                      class="edit-button"
                      ><span id="edit-button-placeholder d-none"></span
                    ></span>
                  }
                  @if (
                    [7, 8, 19].includes(item?.event_action) &&
                    (isAdmin || isDispatchUser) &&
                    detailData?.status?.status_identity?.value == 9
                  ) {
                    <span
                      class="ms-1"
                      (click)="
                        deleteRestoreUserUpdate({
                          event: item,
                          type: item?.is_deleted ? 'restore' : 'delete',
                        })
                      "
                    >
                      @if (item?.is_deleted) {
                        <span>
                          <i
                            class="fa-solid fa-trash-can-arrow-up fs-5 text-secondary"
                          ></i>
                        </span>
                      } @else {
                        <span>
                          <i
                            class="fs-5 fa-solid fa-circle-minus text-danger"
                          ></i>
                        </span>
                      }
                    </span>
                  }
                </div>
                <!-- GPS ACCURACY NOTIFICATION-->
                @if (item?.event_gps?.source) {
                  <div class="warning">
                    @switch (item?.event_gps?.source) {
                      @case (1) {
                        Location Accuracy: Low
                      }
                      @case (2) {
                        Location Accuracy: Very Low
                      }
                    }
                  </div>
                }
                <!--SECTION: EVENT LOCATION-->
                @if (item?.event_gps?.lat && item?.event_gps?.lon) {
                  <div style="margin-bottom: 2rem">
                    <div class="key-label text-secondary">Event Location</div>
                    <div
                      style="max-width: 100%; height: 150px; object-fit: none"
                      class="small"
                    >
                      <gtapp-map-leaflet
                        [customMapConfig]="{ showSimpleStaticMap: true }"
                        [latLon]="{
                          markerTooltip: item?.event_by,
                          lat: item?.event_gps?.lat,
                          lon: item?.event_gps?.lon,
                        }"
                        [mapId]="'map_' + i"
                      ></gtapp-map-leaflet>
                    </div>
                  </div>
                }
                <!--SECTION:  PHOTO COMMENT/NOTES-->
                <div class="d-inline">
                  <div class="gt-multi-line">
                    @if (item?.value) {
                      <span>
                        {{ item?.value }}
                        @if (item.value) {
                          <span (click)="copyContentToClipBoard(item.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        }
                      </span>
                    }
                    @if (
                      detailData?.status?.status_identity?.value == 9 &&
                      (isAdmin || isDispatchUser)
                    ) {
                      <span class="ms-auto">
                        @if (item?.value) {
                          <span
                            (click)="editComment(item, commentRef)"
                            class="edit-button"
                          >
                            <span id="edit-button-placeholder d-none"></span>
                          </span>
                          <span (click)="deleteComment(item)">
                            <i
                              class="fs-5 fa-solid fa-circle-minus text-danger"
                            ></i>
                          </span>
                        } @else {
                          <div
                            class="pt-2"
                            (click)="editComment(item, commentRef)"
                          >
                            <button class="btn btn-secondary btn-sm">
                              Add Remarks
                            </button>
                          </div>
                        }
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    item?.file_extension
                  ) || item?.download_url
                ) {
                  <video
                    controls
                    style="
                      max-height: 100%;
                      max-width: 100%;
                      display: flex;
                      width: 100%;
                    "
                  >
                    <source
                      [src]="item?.download_url || item?.file_url"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    (click)="onOpenImage($event, item)"
                    src="{{ item?.file_url }}"
                    style="max-height: 100%; max-width: 100%; display: flex"
                  />
                }
              </div>
            </div>
          </div>
        }
      }

      @if (promptFileDataUrls?.length && completedTasksData?.length) {
        @for (promptFile of promptFileDataUrls; track $index) {
          <div [id]="'mobile_form_detail' + promptFile?.file_id">
            <ng-container>
              <div class="d-flex mb-2">
                <div
                  [ngClass]="
                    largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                  "
                >
                  <!--SECTION:  PHOTO COMMENT/NOTES-->
                  <div class="d-inline">
                    <div
                      style="color: #00538d"
                      class="gt-multi-line cursor-pointer text-decoration-underline"
                      (click)="
                        scrollToSection(
                          $event,
                          'mobile_form_summary' + promptFile?.file_id
                        )
                      "
                    >
                      @if (promptFile?.description) {
                        <span>
                          {{ promptFile?.description }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
                <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                  @if (
                    [".mp4", ".mov", ".webm", ".mkv"].includes(
                      promptFile?.file_extension
                    )
                  ) {
                    <video autoplay>
                      <source
                        src="{{ promptFile?.file_url }}"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  } @else {
                    <img
                      (click)="onOpenImage($event, promptFile)"
                      src="{{ promptFile?.file_url }}"
                      style="max-height: 100%; max-width: 100%; display: flex"
                    />
                  }
                </div>
              </div>
            </ng-container>
          </div>
        }
      }
    </div>
  }
</div>

<ng-template
  #eventTimeStampUpdateTemplateRef
  let-eventTimeStampUpdateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update {{ data.name }} Time
      <span
        class="float-end"
        (click)="eventTimeStampUpdateTemplateRef.close(false)"
      >
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Select Time"
        [(ngModel)]="data.newValue"
        (change)="changeEventTimeStamp($event, data)"
      />
      <label>Select Time</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="eventTimeStampUpdateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="eventTimeStampUpdateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #statusTimeUpdateTemplateRef
  let-statusTimeUpdateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      <span
        class="float-end"
        (click)="statusTimeUpdateTemplateRef.close(false)"
      >
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    @for (status of data; track status) {
      <div>
        <div class="form-floating mb-3">
          <input
            type="datetime-local"
            class="form-control"
            placeholder="Select {{ status?.status }} Time"
            [(ngModel)]="status.newValue"
            (change)="changeStatusTimeStamp(status, data)"
          />
          <label>Select {{ status?.status }} Time</label>
        </div>
      </div>
    }
    @if (getOnsiteTime(data)) {
      <div class="text-end fw-semibold">
        Time Onsite: {{ getOnsiteTime(data) }}
      </div>
    }

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="statusTimeUpdateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="statusTimeUpdateTemplateRef.close(data)"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #commentRef let-commentRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?.value ? "Edit Comment" : "Add Comment" }}
      <span class="float-end" (click)="commentRef.close(); newComment = ''">
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group">
        <textarea
          class="form-control"
          rows="5"
          wrap="hard"
          placeholder="Enter comment here"
          autofocus
          [(ngModel)]="newComment"
          id="updateCommentBox"
        ></textarea>
        @if (newComment) {
          <span
            class="input-group-text"
            (click)="newComment = ''; clearAndFocusTextBox('updateCommentBox')"
          >
            <i class="fs-5 fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="row row-cols-2 mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-dark btn-lg w-100"
            (click)="commentRef.close(); newComment = ''"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          @if (data?.id && (data?.file || data?.file_url)) {
            <button
              class="btn btn-lg w-100"
              [disabled]="previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
              [ngClass]="newComment ? 'btn-primary' : 'btn-danger'"
            >
              Update
            </button>
          } @else {
            <button
              class="btn btn-primary btn-lg w-100"
              [disabled]="!newComment || previousComment === newComment"
              (click)="addComment(data); commentRef.close()"
            >
              {{ data?.id ? "Update" : "Add" }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Additional Information/ internal notes POPOVER / DIALOG -->
<ng-template
  #jobExtraInfoTemplateRef
  let-data
  let-jobExtraInfoTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      {{ data?._type === "in" ? "Internal Notes" : "Additional Information" }}
      <span class="float-end" (click)="jobExtraInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <!-- Request Detail Section start-->
    @if (data?._type === "in") {
      <div class="mb-3">Will not be shown on reports</div>
    }
    <div class="form-group input-group mb-3">
      <textarea
        class="form-control"
        [placeholder]="
          data?._type === 'in' ? 'Internal Notes' : 'Additional Information'
        "
        cols="20"
        rows="5"
        wrap="hard"
        maxlength="900"
        type="text"
        [(ngModel)]="updatedJobExtraInfo"
        id="aiField"
      ></textarea>
      @if (updatedJobExtraInfo) {
        <span
          class="input-group-text"
          (click)="updatedJobExtraInfo = ''; clearAndFocusTextBox('aiField')"
        >
          <i class="fa-solid fa-xmark"></i>
        </span>
      }
    </div>
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="jobExtraInfoTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="updatedJobExtraInfo === data?.currentValue"
          (click)="
            updateRequestDetails(data?._type); jobExtraInfoTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>
<ng-template
  #modifyExternalJobIdTemplate
  let-modifyExternalJobIdTemplate="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Job Number<span
        class="float-end"
        (click)="modifyExternalJobIdTemplate.close()"
      >
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <!-- Docket No Section start-->
    <div class="input-group">
      <div class="form-floating">
        <input
          class="form-control"
          type="text"
          placeholder="Job Number"
          [(ngModel)]="externalNewJobId"
          autocomplete="off"
          maxlength="32"
          id="eJIdField"
          oninput="this.value = this.value.toUpperCase()"
        />
        <label>Job Number</label>
      </div>
      @if (externalNewJobId) {
        <span
          class="input-group-text"
          (click)="externalNewJobId = ''; clearAndFocusTextBox('eJIdField')"
        >
          <i class="fs-5 fa-solid fa-xmark"></i>
        </span>
      }
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="modifyExternalJobIdTemplate.close()"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="externalOldJobId === externalNewJobId"
          (click)="updateJobId(); modifyExternalJobIdTemplate.close()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- UPDATE MONITORING COMPANY DIALOG -->
<ng-template #modifyMCTemplate let-modifyMCTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Monitoring Company
      <span class="float-end" (click)="modifyMCTemplate.close()">
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="mb-3">
      <gtapp-auto-complete
        [data]="monitoringCompanyList"
        placeHolder="Monitoring Company"
        searchKeyword="company_name"
        [itemTemplate]="MCTemplate"
        [initialValue]="mcInputValue"
        [addInitialKey]="
          detailData?.status?.status_identity?.value == 9 &&
          (isAdmin || isDispatchUser)
        "
        (inputChanged)="onMcSearch($event)"
        (selected)="addMC($event)"
        [inputId]="'mcId'"
        [enableCloseOption]="true"
        (fieldCleared)="editField('mc')"
      >
      </gtapp-auto-complete>
    </div>

    <ng-template #MCTemplate let-item>
      @if (item?.key === 0) {
        <div>Add Monitoring Company</div>
      } @else {
        <div>
          {{ item.company_name }}
        </div>
      }
    </ng-template>
    @if (detailData?.monitoring_company?.id) {
      <div class="row row-cols-1 mt-2 mx-auto">
        <div class="col">
          <button
            (click)="
              modifyMCTemplate.close();
              updateData({ monitoring_company_id: null })
            "
            class="btn btn-danger btn-lg px-5"
          >
            Clear
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<!-- edit response type  DIALOG -->
<ng-template
  #responseTypeTemplateRef
  let-responseTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Response Type

      <span class="float-end" (click)="responseTypeTemplateRef.close()">
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="mb-3">
        <gtapp-auto-complete
          [data]="responseTypeList"
          [maxLength]="256"
          placeHolder="Search Response Type"
          searchKeyword="name"
          [initialValue]="previousResponseTypeValue"
          [itemTemplate]="responseTypeTemplate"
          [addInitialKey]="
            detailData?.status?.status_identity?.value == 9 &&
            (isAdmin || isDispatchUser)
          "
          (inputChanged)="onSearchResponseType($event)"
          (selected)="onSelectResponseType($event)"
          [inputId]="'rtId'"
          [enableCloseOption]="true"
          (fieldCleared)="editField('rt')"
        >
        </gtapp-auto-complete>
      </div>

      <ng-template #responseTypeTemplate let-item>
        @if (item?.key === 0) {
          <div>Add New Response Type</div>
        } @else {
          <div>{{ item?.name }}</div>
        }
      </ng-template>

      @if (detailData?.response_type?.id) {
        <div class="row row-cols12 mt-2">
          <div class="col">
            <button
              (click)="
                responseTypeTemplateRef.close();
                updateData({ response_type_id: null })
              "
              class="btn btn-outline-danger btn-lg w-100"
            >
              Remove Response Type
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
<!-- edit service type  DIALOG -->
<ng-template
  #serviceTypeTemplateRef
  let-serviceTypeTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Service Type

      <span class="float-end" (click)="serviceTypeTemplateRef.close()">
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <div>
      <div class="mb-3">
        <gtapp-auto-complete
          [data]="serviceTypeListData"
          [maxLength]="256"
          placeHolder="Search Service Type"
          searchKeyword="name"
          [initialValue]="previousServiceTypeValue"
          [itemTemplate]="serviceTypeTemplate"
          [addInitialKey]="
            detailData?.status?.status_identity?.value == 9 &&
            (isAdmin || isDispatchUser)
          "
          (inputChanged)="onSTSearch($event)"
          (selected)="onServiceTypeSelect($event)"
          [inputId]="'stId'"
          [enableCloseOption]="true"
          (fieldCleared)="editField('st')"
        >
        </gtapp-auto-complete>
      </div>

      <ng-template #serviceTypeTemplate let-item>
        @if (item?.key === 0) {
          <div>Add New Service Type</div>
        } @else {
          <div>{{ item?.name }}</div>
        }
      </ng-template>

      @if (detailData?.job_service_type?.id) {
        <div class="row row-cols12 mt-2">
          <div class="col">
            <button
              (click)="
                serviceTypeTemplateRef.close();
                updateData({ service_type_id: null })
              "
              class="btn btn-outline-danger btn-lg w-100"
            >
              Remove Service Type
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #reportDateTemplateRef
  let-reportDateTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Update Report Date
      <span class="float-end" (click)="reportDateTemplateRef.close(false)">
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="form-floating mb-3">
      <input
        type="date"
        class="form-control"
        placeholder="Report Date"
        [(ngModel)]="data.newValue"
        (change)="changeEventTimeStamp($event, data)"
      />
      <label>Report Date</label>
    </div>

    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="reportDateTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="reportDateTemplateRef.close(data)"
          [disabled]="!data?.valid"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #sealInfoTemplateRef let-sealInfoTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Seal Information
      <span class="float-end" (click)="sealInfoTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="my-3">
      <label
        ><input
          class="form-check-input"
          type="checkbox"
          [checked]="sealInfo?.site_sealed"
          (change)="
            sealInfo?.site_sealed
              ? (sealInfo = { internal_check: true })
              : (sealInfo = { internal_check: true, site_sealed: true })
          "
        />
        Site Sealed
      </label>
    </div>
    @if (sealInfo?.site_sealed) {
      <div class="input-group my-3">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            placeholder="Cleared By"
            [(ngModel)]="sealInfo.cleared_by"
            id="sealClearedByFieldId"
          />
          <label>Cleared By</label>
        </div>

        @if (sealInfo?.cleared_by) {
          <span
            class="input-group-text"
            (click)="
              sealInfo.cleared_by = ''; shiftFocus('sealClearedByFieldId')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    } @else {
      <div class="form-group input-group col">
        <textarea
          class="form-control"
          placeholder="Reason"
          rows="2"
          wrap="hard"
          type="text"
          autofocus
          [(ngModel)]="sealInfo.uncleared_reason"
          id="sealUnClearedReasonFieldId"
        ></textarea>
        @if (sealInfo?.uncleared_reason) {
          <span
            class="input-group-text"
            (click)="
              sealInfo.uncleared_reason = '';
              shiftFocus('sealUnClearedReasonFieldId')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    }
    <div class="row row-cols-2 mt-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="sealInfoTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          [disabled]="
            sealInfo?.site_sealed
              ? !sealInfo?.cleared_by
              : !sealInfo.uncleared_reason
          "
          (click)="
            updateData({ seal_info: sealInfo }); sealInfoTemplateRef.close()
          "
        >
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sendDocketTemplate let-sendDocketTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Send Docket
      <span class="float-end" (click)="sendDocketTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="d-flex px-4 flex-column gap-3">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="sendNowOption"
          [checked]="sendDocketOptionSelected === 1"
          (change)="sendDocketOptionSelected = 1"
        />
        <label class="form-check-label" for="sendNowOption"> Send Now </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="sendOnceLaterOption"
          [checked]="sendDocketOptionSelected === 2"
          (change)="sendDocketOptionSelected = 2"
        />
        <label class="form-check-label" for="sendOnceLaterOption">
          Send After
        </label>
      </div>
      @if (sendDocketOptionSelected === 2) {
        <div class="d-flex align-items-center">
          <div class="form-floating mb-3">
            <input
              type="datetime-local"
              class="form-control"
              placeholder="Select Date & Time"
              [(ngModel)]="sendDocketOnceAT"
              (change)="roundDateTimeToQuarterHour($event)"
              [min]="today"
            />
            <label>Date and Time</label>
          </div>
        </div>
      }
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="sendWithRepeatOption"
          [checked]="sendDocketOptionSelected === 3"
          (change)="sendDocketOptionSelected = 3"
        />
        <label class="form-check-label" for="sendWithRepeatOption">
          Setup a schedule
        </label>
      </div>
    </div>

    <div class="row row-cols-2 my-3">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark btn-lg w-100"
          (click)="sendDocketTemplateRef.close()"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="sendDocketTemplateRef.close(sendDocketOptionSelected)"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #configuredMailScheduleTemplate let-schedule="value">
  @if (schedule?.id) {
    <!--setup as a site/client scheduled report-->
    <div class="d-flex align-items-center gap-4">
      <div class="link-view" (click)="redirectToScheduledReportsTab(schedule)">
        Report scheduled to send after
        <span class="fw-bold">
          {{ schedule?.mail_time }}
        </span>
      </div>
      <div (click)="removeSchedule(schedule)">
        <i class="text-danger fa-solid fa-circle-minus fs-5"></i>
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center gap-4">
      <!--setup as a one time job only report-->
      <div>
        Report will be sent after
        <span class="fw-semibold">
          {{ schedule?.mail_time | customDate: "d MMM y HH:mm" }}
        </span>
      </div>
      <div (click)="removeSchedule(schedule)">
        <i class="text-danger fa-solid fa-circle-minus fs-5"></i>
      </div>
    </div>
  }
</ng-template>
<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <dl [id]="'mobile_form_summary' + dataItem?.file_id">
      @if (dataItem?.file_id && promptFileDataUrls?.length) {
        <a
          class="cursor-pointer"
          (click)="
            scrollToSection($event, 'mobile_form_detail' + dataItem?.file_id)
          "
          style="color: #00538d"
        >
          <dt class="text-uppercase">{{ dataItem?.description }}</dt>
        </a>
      } @else {
        <dt class="text-uppercase">{{ dataItem?.description }}</dt>
      }
      <dd>{{ dataItem | misc: "promptValue" }}</dd>
    </dl>
  }
  @for (option of dataItem?.options; track option) {
    <div class="nested-prompt">
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>

<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Recipients
      <span
        class="float-end"
        (click)="reportConfirmationTemplateRef.close(false)"
      >
        <i class="fs-5 fa-solid fa-xmark"></i>
      </span>
    </div>
    @if (sendDocketOptionSelected == 2 && sendDocketOnceAT) {
      <div class="alert alert-info">
        Docket is scheduled to send at
        <span class="fw-semibold">
          {{ sendDocketOnceAT | customDate: "d MMM y HH:mm" }}
        </span>
      </div>
    }

    @if (
      reportRecipientContactsDataDict?.site_contacts?.length ||
      reportRecipientContactsDataDict?.client_contacts?.length
    ) {
      @if (detailData?.roster_scheduler?.id) {
        <ul class="nav nav-tabs my-2" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="site-contacts-tab"
              data-bs-toggle="tab"
              data-bs-target="#site-contacts"
              type="button"
              role="tab"
              aria-controls="site-contacts"
              aria-selected="true"
            >
              Site Contacts
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="client-contacts-tab"
              data-bs-toggle="tab"
              data-bs-target="#client-contacts"
              type="button"
              role="tab"
              aria-controls="client-contacts"
              aria-selected="false"
            >
              Client Contacts
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="site-contacts"
            role="tabpanel"
            aria-labelledby="site-contacts-tab"
          >
            <div class="col-lg-6 mb-3">
              <button
                class="btn btn-sm btn-primary w-100"
                (click)="redirectToSite()"
              >
                {{
                  reportRecipientContactsDataDict?.site_contacts?.length
                    ? "Edit Recipients"
                    : "Add Recipients"
                }}
              </button>
            </div>
            @if (reportRecipientContactsDataDict?.site_contacts?.length) {
              <ng-template
                *ngTemplateOutlet="
                  contactRecipientSelectionTemplate;
                  context: {
                    reportRecipientList:
                      reportRecipientContactsDataDict?.site_contacts,
                  }
                "
              ></ng-template>
            }
          </div>
          <div
            class="tab-pane fade"
            id="client-contacts"
            role="tabpanel"
            aria-labelledby="client-contacts-tab"
          >
            <div class="col-lg-6 mb-3">
              <button
                class="btn btn-sm btn-primary w-100"
                (click)="redirectToSite('client')"
              >
                {{
                  reportRecipientContactsDataDict?.client_contacts?.length
                    ? "Edit Recipients"
                    : "Add Recipients"
                }}
              </button>
            </div>
            @if (reportRecipientContactsDataDict?.client_contacts?.length) {
              <ng-template
                *ngTemplateOutlet="
                  contactRecipientSelectionTemplate;
                  context: {
                    reportRecipientList:
                      reportRecipientContactsDataDict?.client_contacts,
                  }
                "
              ></ng-template>
            }
          </div>
        </div>
      } @else {
        <div class="row row-cols-2 mb-3">
          <div class="col">
            <button
              class="btn btn-sm btn-primary w-100"
              (click)="redirectToSite()"
            >
              Edit Recipients (Site)
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-sm btn-outline-primary w-100"
              (click)="redirectToSite('client')"
            >
              Edit Recipients (Client)
            </button>
          </div>
        </div>
        <ng-template
          *ngTemplateOutlet="
            contactRecipientSelectionTemplate;
            context: {
              reportRecipientList: (
                reportRecipientContactsDataDict?.site_contacts || []
              )?.concat(reportRecipientContactsDataDict?.client_contacts || []),
            }
          "
        ></ng-template>
      }
    } @else {
      <div class="mb-2 alert alert-danger">
        There are no recipients configured for this site
      </div>
      <div class="row mb-2">
        <div class="col">
          <button
            class="btn btn-lg btn-primary w-100"
            (click)="redirectToSite()"
          >
            Add Recipients (Site)
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg btn-outline-primary w-100"
            (click)="redirectToSite('client')"
          >
            Add Recipients (Client)
          </button>
        </div>
      </div>
    }
    @if (eventsOutsideStatusTimeStamps?.length) {
      <div class="alert alert-warning text-center">
        WARNING: There are events occurring outside the onsite window.
      </div>
    }
    @if (selectedReportRecipientSet.size) {
      <dt class="text-end me-4 pt-2">
        Total Recipients Selected:
        <span class="fw-semibold fs-6">{{
          selectedReportRecipientSet.size
        }}</span>
      </dt>
    }

    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          type="button"
          (click)="reportConfirmationTemplateRef.close(false)"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100"
          [ngClass]="
            eventsOutsideStatusTimeStamps?.length
              ? 'btn-warning'
              : 'btn-success'
          "
          type="button"
          (click)="reportConfirmationTemplateRef.close(true)"
          [disabled]="!selectedReportRecipientSet.size"
        >
          {{
            eventsOutsideStatusTimeStamps?.length
              ? sendDocketOptionSelected == 2 && sendDocketOnceAT
                ? "Ignore and Schedule Report"
                : "Ignore and Send Report"
              : sendDocketOptionSelected == 2 && sendDocketOnceAT
                ? "Schedule Report"
                : "Send Report"
          }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #contactRecipientSelectionTemplate
  let-reportRecipientList="reportRecipientList"
>
  <div class="row row-cols-1 row-cols-lg-2 row-cols-xxl-3 mb-4">
    @if (reportRecipientList?.length > 1) {
      <div class="col-12 col-lg-12 col-xxl-12 text-primary form-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="
            selectedReportRecipientSet.size === reportRecipientList?.length
          "
          (change)="
            selectAllContactReportRecipients($event, reportRecipientList)
          "
          id="selectAllBox"
        />
        <label for="selectAllBox"
          >Select All [{{ reportRecipientList?.length }}]</label
        >
      </div>
    }
    @for (contact of reportRecipientList; track contact; let i = $index) {
      <div class="col form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="selectedReportRecipientSet.has(contact?.id)"
          (change)="selectUnselectRecipients(contact)"
          id="check-{{ contact.id }}-{{ i }}"
        />
        <label class="form-check-label" for="check-{{ contact.id }}-{{ i }}">
          {{ contact?.user_full_name || contact?.full_name }}
          @if (contact?.is_site_contact) {
            <span class="small-font text-secondary">[Site Contact]</span>
          }
          <div class="small-font">
            {{ contact?.user_email || contact?.email }}
          </div>
        </label>
      </div>
    }
  </div>
</ng-template>
